export default __webpack_public_path__ + "static/media/logo.0524b9c3.png";